/**
 * Created by RSchweber-Koren on 4/18/2017.
 */

import angular from "angular";

import Assert from "tbAssert";

const userMessagesTable = new Map([
    // 0x0000 - 0x0FFF: Generic messages
    [0x0000, "The operation completed successfully."],
    [0x0001, "An unexpected error occurred."],
    [0x0002, "Please reload the page to continue."],
    [0x0003, "Hide"],
    [0x0004, "Show"],

    //0x1000 - 0x14FF: Event Editor Success and Information Messages
    [0x1000, "Event loaded successfully"],
    [0x1001, "Loading"],
    [0x1002, "Loaded subscriber information successfully."],
    [0x1003, "Saving"],
    [0x1004, "Changes saved successfully."],
    [0x1005, "Reloading Event from Server"],
    [0x1006, "Event data reloaded successfully."],
    [0x1007, "Updating assigned trackers"],
    [0x1008, "Successfully updated event trackers"],
    [0x1009, "Saving Attendees List"],
    [0x100A, "Successfully updated event attendees."],
    [0x100B, "Updating Event Status"],
    [0x100C, "Event status updated successfully."],
    [0x100D, "Loading event report dialog..."],
    [0x100E, "Report updated. Reloading..."],
    [0x100F, "Report information sucessfully updated."],
    [0x1010, "Successfully retrieved tracking report."],
    [0x1011, "Saving Updated Event Types"],
    [0x1012, "Updated event types saved successfully."],
    [0x1013, "Deleting Event"],
    [0x1014, "Event deleted. Returning to the calendar."],
    [0x1015, "Loading State Data"],
    [0x1016, "Loading Event Type Data"],
    [0x1017, "Loading Time Zone Data"],
    [0x1018, "Loading Event Data"],
    // This is the help text for the internal-only event field. Used in multiple places (e.g, event editor, create event dialog)
    [0x1019, "Only American Bridge staff or those with equivalent access will see this event or receive emailed tracking reports for it."],
    // This is the help text for the internal-only recipient field in the subscription management recipient edit view
    [0x1020, "Receives subscription emails for internal-only events. Note: if the subscriber's email address has an American Bridge domain, it will also be treated as \"internal\" even if not explicitly marked here."],
    // This is the help text for the external-only event field, Used in a similar number of places as the internal-only help text
    [0x1021, "American Bridge staff (and any recipient explicitly marked as \"internal\") will not receive email notifications for this event. TRACKING SHOULD NEVER SET THIS."],

    //0x1500 - 0x19FF: Event Editor Warning Messages
    [0x1500, "This event is marked as external-only, but that option is hidden by the current global view."],

    //0x1A00 - 0x1FFF: Event Editor Error Messages
    [0x1A00, "Invalid event id Value: redirecting to calendar home"],
    [0x1A01, "An error occurred while initializing the event editor. Returning to the tracking calendar."],
    [0x1A02, "Current Editor event is invalid. Please refresh the page, and contact TrackerBase support if the message recurs."],
    [0x1A03, "An unexpected error occurred while we attempted to load/clear the event subscriber information."],
    [0x1A04, "Error loading event subscribers list"],
    [0x1A05, "We were unable to save your changes to the server. Please try again, or contact TrackerBase support."],
    [0x1A06, "An unexpected error occurred while we attempted to save your changes to the server."],
    [0x1A07, "An error occurred while showing the unsaved changes warning. Further data may be available in the log."],
    [0x1A08, "An unexpected error occurred while we attempted to reload the event from the server."],
    [0x1A09, "An error occurred while showing the trackers editor dialog. Further data may be available in the log."],
    [0x1A0A, "An error occurred while showing the delete event confirmation dialog. Further data may be available in the log."],
    [0x1A0B, "Unable to update event status. Please retry after refreshing the page, or contact support if this error repeats."],
    [0x1A0C, "An error occurred while showing the event attendees dialog. Further data may be available in the log."],
    [0x1A0D, "An unexpected error occurred when we attempted to delete this event. Please refresh the page to continue."],
    [0x1A0E, "An unexpected error occurred when we tried to update this event's status. Please contact support."],
    [0x1A0F, "Report update failed. See the error log for further details."],
    [0x1A10, "An unexpected error occurred when we tried to update the report for this event. Please contact support."],
    [0x1A11, "An error occurred while trying to retrieve the tracking report."],
    [0x1A12, "An unexpected error occurred while we attempted to retrieve the tracking report."],
    [0x1A13, "An error occurred while loading state data"],
    [0x1A14, "An error occurred while retrieving event types"],
    [0x1A15, "There was an error loading time zone data from the server"],

    //0x2000 - 0x24FF: TrackerBase Report Status and Info Messages
    [0x2000, "Sending out report (this may take some time) ..."],
    [0x2001, "Tracking Summary Report sent successfully"],
    [0x2002, "Sending out schedule (this may take some time) ..."],
    [0x2003, "Tracking Schedule sent successfully"],
    [0x2004, "Loading report data ..."],
    [0x2005, "Report data loaded."],

    //0x2500 - 0x29FF: TrackerBase Report Warning Messages

    //0x2A00 - 0x2FFF: TrackerBase Report Error Messages
    [0x2A00, "Unable to send the tracking summary report"],
    [0x2A01, "Unable to send the tracking schedule"],
    [0x2A02, "At least one error occurred while loading report data. See the console for details."],

    //0x3000 - 0x37FF: TrackerBase Subscription Management Messages
    [0x3000, "Office to election subscription conversion failed"],
    [0x3001, "no future elections found for this office."],
    [0x3002, "Unable to store subscription editor message"],

    //0xFFFF: Placeholder
    [0xFFFF, "The Sound and the Fury"]
]);

const mLogSvc = new WeakMap();

class UserMessagesService {
    constructor($log) {
        $log.debug(`User Messages Service: initialized with ${userMessagesTable.size} entries.`);
        mLogSvc.set(this, $log);
    }

    getUserMessage({msgId}) {
        const userMessage = userMessagesTable.get(msgId);
        Assert.StrictAssert(userMessage != null, `User Messages Service: invalid message id '${msgId}'`);
        return userMessage;
    }

    tryTranslateUserMessage({msg: purportedMsgId}) {
        const userMessage = userMessagesTable.get(purportedMsgId);

        if (userMessage != null) {
            return userMessage;
        }
        else {
            mLogSvc.get(this).debug(`User Message Service: Passing Through Message '${purportedMsgId}'`);
            return purportedMsgId;
        }
    }
}

UserMessagesService.$inject = [
    "$log"
];

export default angular
    .module("trackerbase-app.services.user-messages-service",[])
    .service("UserMessages", UserMessagesService)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/UserMessagesService.js
// module id = BZEs
// module chunks = 1